import { gql } from '@apollo/client'

export const CLOSED_REPORT_QUERY = gql`
  query closedReport($filter: ClosedReportFilter!) {
    closedReport(filter: $filter) {
      mainPeriod {
        serviceCallCount
        legalAdviceCount
        legalAdviceInMediationCount
        mediationCount
        courtRepresentationCount
        jumpOffCount
      }
      comparisionPeriod {
        serviceCallCount
        legalAdviceCount
        legalAdviceInMediationCount
        mediationCount
        courtRepresentationCount
        jumpOffCount
      }
      trend {
        serviceCallCount
        legalAdviceCount
        legalAdviceInMediationCount
        mediationCount
        courtRepresentationCount
        jumpOffCount
      }
      diff {
        serviceCallCount
        legalAdviceCount
        legalAdviceInMediationCount
        mediationCount
        courtRepresentationCount
        jumpOffCount
      }
    }
  }
`
